/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {pdf} from '@react-pdf/renderer'
import {
  SortingState,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'

import {PaginationModel} from '../../models/PaginationModel'

import notifyToast from '../../components/Toast/Toast'

import {TableActionButton} from '../../components/TableActionBtn/TableActionButton'

import {KTCard, KTCardBody, KTIcon} from '../../../_websoft/helpers'

import {ToastContainer} from 'react-toastify'

import TableSearch from '../../components/TableSearch/TableSearch'

import ExportButton from '../../components/TableExportToExcel/ExportButton'

import LoadingComponent from '../../components/LoadingComponent/LoadingComponent'

import TablePagination from '../../components/TablePagination/TablePagination'

import moments from 'moment'

import {
  deleteNajavaUtovara,
  getNajavaUtovara,
  getNajaveUtovara,
  updateNajavaUtovara,
} from '../../api/proizvodnja'
import {vozaciSearch} from '../../api/partneri'
import NajavaUtovaraPdf from './components/UtovarKamiona/NajavaUtovaraPdf'
import {getNajavaUtovaraPdfData} from './components/UtovarKamiona/najavaUtovaraPdfData'
import ThermoboardNajavaModal from './components/UtovarKamiona/ThermoboardNajavaModal'

const getResponseRows = (response: any) => {
  if (Array.isArray(response)) return response
  if (Array.isArray(response?.data)) return response.data
  if (Array.isArray(response?.data?.data)) return response.data.data
  return []
}

const NajaveUtovaraList = ({kupacFilter = ''}: {kupacFilter?: string}) => {
  const cijenaTransportaKurs = 1.95
  const navigate = useNavigate()

  const [data, setData] = useState<any[]>([])

  const [loading, setLoading] = useState(true)

  const [pagination, setpagination] = useState<PaginationModel>({
    curPage: 1,
    totalPage: 1,
    perPage: 10,
  })

  const [params, setparams] = useState<any>({
    per_page: 10,
    page: 1,
  })

  const [sorting, setSorting] = useState<SortingState>([])

  const [globalFilter, setGlobalFilter] = React.useState('')

  const [showEditModal, setShowEditModal] = useState(false)
  const [showThermoboardModal, setShowThermoboardModal] = useState(false)
  const [showNaloziModal, setShowNaloziModal] = useState(false)
  const [loadingNaloziModal, setLoadingNaloziModal] = useState(false)
  const [selectedNaloziNajava, setSelectedNaloziNajava] = useState<any>(null)
  const [selectedNajavaId, setSelectedNajavaId] = useState<number | null>(null)
  const [editForm, setEditForm] = useState<any>({})
  const [editStavke, setEditStavke] = useState<any[]>([])
  const [selectedVozac, setSelectedVozac] = useState<any>(null)
  const [vozaciOptions, setVozaciOptions] = useState<any[]>([])
  const [vozaciLoading, setVozaciLoading] = useState(false)
  const [vozaciSearchTouched, setVozaciSearchTouched] = useState(false)

  // ----------------------------------------------------
  // LOAD DATA
  // ----------------------------------------------------

  const updatePage = () => {
    setLoading(true)

    getNajaveUtovara(params.page, params.per_page, globalFilter, 'Id', 'DESC', kupacFilter)
      .then((response) => {
        const responseData = response.data.data

        setData(responseData)

        setpagination({
          curPage: response.data.current_page,
          totalPage: response.data.last_page,
          perPage: response.data.per_page,
        })
      })
      .catch((error) => {
        console.error(error)

        notifyToast(false, error?.response?.data?.message ?? error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    updatePage()
  }, [params, globalFilter, kupacFilter])

  const getValue = (item: any, keys: string[], fallback: any = '') => {
    for (const key of keys) {
      if (item?.[key] !== undefined && item?.[key] !== null) {
        return item[key]
      }
    }

    return fallback
  }

  const getNestedValue = (item: any, path: string) => {
    return path.split('.').reduce((value, key) => value?.[key], item)
  }

  const formatDateForInput = (value: any) => {
    if (!value) {
      return ''
    }

    return moments(value).format('YYYY-MM-DD')
  }

  const normalizeDodatniUtovar = (value: any) => {
    return value === true || value === 1 || value === '1' || String(value).toUpperCase() === 'DA'
      ? 'DA'
      : 'NE'
  }

  const formatCalculatedPrice = (value: number) => {
    if (!Number.isFinite(value)) {
      return ''
    }

    return value.toFixed(2)
  }

  const setEditField = (field: string, value: any) => {
    setEditForm((prev: any) => ({
      ...prev,
      [field]: value,
    }))
  }

  useEffect(() => {
    const search = String(editForm.vozacIme ?? '').trim()

    if (!showEditModal || selectedVozac || search.length < 3) {
      setVozaciOptions([])
      setVozaciLoading(false)
      setVozaciSearchTouched(showEditModal && search.length >= 3)
      return
    }

    setVozaciLoading(true)
    setVozaciSearchTouched(true)

    const timeout = setTimeout(async () => {
      try {
        const response = await vozaciSearch({search})
        setVozaciOptions(getResponseRows(response))
      } catch (error: any) {
        console.error(error)
        setVozaciOptions([])
        notifyToast(false, error?.response?.data?.message ?? 'Greska prilikom pretrage vozaca.')
      } finally {
        setVozaciLoading(false)
      }
    }, 300)

    return () => clearTimeout(timeout)
  }, [editForm.vozacIme, selectedVozac, showEditModal])

  const selectVozac = (vozac: any) => {
    setSelectedVozac(vozac)
    setEditForm((prev: any) => ({
      ...prev,
      vozacIme: vozac?.ImePrezimeVozaca ?? '',
      vozacFirma: vozac?.VozacFirma ?? vozac?.Firma ?? vozac?.PartnerNaziv ?? '',
      vozacTel: vozac?.PartnerMobitel ?? '',
      regKamion: vozac?.RegistracijaKamiona ?? vozac?.Registracija ?? '',
      regPrikolica: vozac?.RegistracijaPrikolice ?? '',
      brojPasosa: vozac?.BrojDokumenta ?? '',
    }))
    setVozaciOptions([])
  }

  const clearSelectedVozac = () => {
    setSelectedVozac(null)
    setEditField('vozacIme', '')
    setEditField('vozacFirma', '')
    setVozaciOptions([])
    setVozaciSearchTouched(false)
  }

  const getStavkaValue = (stavka: any) => {
    return getValue(stavka, ['Stavka', 'stavka', 'StavkaNaloga', 'stavkaNaloga'], '-')
  }

  const getSifraValue = (stavka: any) => {
    return (
      getNestedValue(stavka, 'proizvodnja.artikal') ??
      getValue(
        stavka,
        ['SifraArtikla', 'sifraArtikla', 'Sifra', 'sifra', 'Artikal', 'artikal'],
        '-'
      )
    )
  }

  const getBojaValue = (stavka: any) => {
    const flatBoja = getValue(stavka, ['Boja', 'boja', 'BojaArtikla', 'bojaArtikla'], '')

    const bojaGore =
      getNestedValue(stavka, 'proizvodnja.boja_gore.BojaNaziv') ??
      getNestedValue(stavka, 'proizvodnja.boja_gore.naziv') ??
      getNestedValue(stavka, 'proizvodnja.boja_gore.Naziv') ??
      getNestedValue(stavka, 'proizvodnja.bojaGore.BojaNaziv') ??
      getNestedValue(stavka, 'proizvodnja.bojaGore.naziv') ??
      getNestedValue(stavka, 'proizvodnja.bojaGore.Naziv') ??
      getNestedValue(stavka, 'proizvodnja.boja_bore.BojaNaziv') ??
      getNestedValue(stavka, 'proizvodnja.boja_bore.naziv') ??
      getNestedValue(stavka, 'boja_gore.BojaNaziv') ??
      getNestedValue(stavka, 'boja_gore.naziv') ??
      getNestedValue(stavka, 'boja_gore.Naziv') ??
      getNestedValue(stavka, 'bojaGore.BojaNaziv') ??
      getNestedValue(stavka, 'bojaGore.naziv') ??
      getNestedValue(stavka, 'bojaGore.Naziv') ??
      getNestedValue(stavka, 'boja_bore.BojaNaziv') ??
      getNestedValue(stavka, 'boja_bore.naziv')

    const bojaDole =
      getNestedValue(stavka, 'proizvodnja.boja_dole.BojaNaziv') ??
      getNestedValue(stavka, 'proizvodnja.boja_dole.naziv') ??
      getNestedValue(stavka, 'proizvodnja.boja_dole.Naziv') ??
      getNestedValue(stavka, 'proizvodnja.bojaDole.BojaNaziv') ??
      getNestedValue(stavka, 'proizvodnja.bojaDole.naziv') ??
      getNestedValue(stavka, 'proizvodnja.bojaDole.Naziv') ??
      getNestedValue(stavka, 'boja_dole.BojaNaziv') ??
      getNestedValue(stavka, 'boja_dole.naziv') ??
      getNestedValue(stavka, 'boja_dole.Naziv') ??
      getNestedValue(stavka, 'bojaDole.BojaNaziv') ??
      getNestedValue(stavka, 'bojaDole.naziv') ??
      getNestedValue(stavka, 'bojaDole.Naziv')

    if (bojaGore || bojaDole) {
      return `${bojaGore ?? '-'} / ${bojaDole ?? '-'}`
    }

    if (flatBoja && flatBoja !== '-' && flatBoja !== '- / -') {
      return flatBoja
    }

    return '-'
  }

  const handleEditPriceBamChange = (value: string) => {
    const numericValue = Number(value)

    setEditForm((prev: any) => ({
      ...prev,
      ugovorenaCijenaBam: value,
      ugovorenaCijenaEur:
        value && !isNaN(numericValue)
          ? formatCalculatedPrice(numericValue / cijenaTransportaKurs)
          : '',
    }))
  }

  const handleEditPriceEurChange = (value: string) => {
    const numericValue = Number(value)

    setEditForm((prev: any) => ({
      ...prev,
      ugovorenaCijenaEur: value,
      ugovorenaCijenaBam:
        value && !isNaN(numericValue)
          ? formatCalculatedPrice(numericValue * cijenaTransportaKurs)
          : '',
    }))
  }

  const openEditModal = (najava: any) => {
    const stavke = najava?.stavke ?? najava?.NajavaUtovaraStavke ?? []
    const firstStavka = stavke[0] ?? {}

    setSelectedVozac(null)
    setVozaciOptions([])
    setVozaciSearchTouched(false)
    setSelectedNajavaId(najava.Id)
    setEditForm({
      kupac: getValue(najava, ['Kupac', 'kupac']),
      kontaktOsoba: getValue(najava, ['KontaktOsoba', 'kontaktOsoba']),
      vozacIme: getValue(najava, ['VozacIme', 'vozacIme']),
      vozacFirma: getValue(najava, ['VozacFirma', 'vozacFirma']),
      vozacTel: getValue(najava, ['VozacTel', 'vozacTel']),
      regKamion: getValue(najava, ['RegKamion', 'regKamion']),
      regPrikolica: getValue(najava, ['RegPrikolica', 'regPrikolica']),
      datumUtovara: formatDateForInput(getValue(najava, ['DatumUtovara', 'datumUtovara'])),
      vrijemeUtovara: getValue(najava, ['VrijemeUtovara', 'vrijemeUtovara']),
      granicniPrelaz: getValue(najava, ['GranicniPrelaz', 'granicniPrelaz']),
      brojPasosa: getValue(najava, ['BrojPasosa', 'brojPasosa']),
      emailDokumentacija: getValue(najava, ['EmailDokumentacija', 'emailDokumentacija']),
      napomene: getValue(najava, ['Napomene', 'napomene']),
      istovar1: getValue(firstStavka, ['Istovar1', 'istovar1']),
      istovar1Kontakt: getValue(firstStavka, [
        'KontaktIstovar1',
        'kontaktIstovar1',
        'Istovar1Kontakt',
      ]),
      istovar2: getValue(firstStavka, ['Istovar2', 'istovar2']),
      istovar2Kontakt: getValue(firstStavka, [
        'KontaktIstovar2',
        'kontaktIstovar2',
        'Istovar2Kontakt',
      ]),
      ugovorenaCijenaBam: getValue(najava, ['UgovorenaCijenaTransportaKM', 'ugovorenaCijenaBam']),
      ugovorenaCijenaEur: getValue(najava, ['UgovorenaCijenaTransportaEUR', 'ugovorenaCijenaEur']),
      dodatniUtovarRobe: normalizeDodatniUtovar(
        getValue(najava, ['DodatniUtovar', 'dodatniUtovarRobe'], false)
      ),
      brojNalogaDodatniUtovarRobe: getValue(najava, [
        'DodatniUtovarNalozi',
        'brojNalogaDodatniUtovarRobe',
      ]),
      transport: getValue(najava, ['Transport', 'transport']),
      fakturisatiTransport: normalizeDodatniUtovar(
        getValue(najava, ['FakturisatiTransport', 'fakturisatiTransport'], false)
      ),
      fakturisatiTransportNalog: getValue(najava, [
        'FakturisatiTransportNalog',
        'fakturisatiTransportNalog',
      ]),
      carisnkiPostupak: getValue(najava, ['CarisnkiPostupak', 'carisnkiPostupak']),
    })
    setEditStavke(
      stavke.map((stavka: any) => ({
        ...stavka,
        napomena: getValue(stavka, ['napomena', 'Napomena']),
        istovar: getValue(stavka, ['istovar', 'Istovar'], 'Istovar 1'),
      }))
    )
    setShowEditModal(true)
  }

  const openPdf = async (najava: any) => {
    try {
      const id = getValue(najava, ['Id', 'id'], null)
      let pdfNajavaData = najava

      if (id) {
        const response = await getNajavaUtovara(id)
        pdfNajavaData = getNajavaPayload(response)
      }

      const blob = await pdf(<NajavaUtovaraPdf data={getNajavaUtovaraPdfData(pdfNajavaData)} />).toBlob()

      const url = URL.createObjectURL(blob)

      window.open(url, '_blank')
    } catch (error: any) {
      console.error(error)

      notifyToast(false, error?.response?.data?.message ?? 'Greska prilikom generisanja PDF-a.')
    }
  }

  const getNajavaPayload = (response: any) => {
    return response?.data?.data ?? response?.data ?? response
  }

  const openNaloziModal = async (najava: any) => {
    const id = getValue(najava, ['Id', 'id'], null)

    setSelectedNaloziNajava(najava)
    setShowNaloziModal(true)

    if (!id) {
      return
    }

    setLoadingNaloziModal(true)

    try {
      const response = await getNajavaUtovara(id)
      const najavaDetalji = getNajavaPayload(response)

      setSelectedNaloziNajava(najavaDetalji)
    } catch (error: any) {
      console.error(error)

      notifyToast(
        false,
        error?.response?.data?.message ?? 'Greska prilikom ucitavanja detalja najave utovara.'
      )
    } finally {
      setLoadingNaloziModal(false)
    }
  }

  // ----------------------------------------------------
  // TABLE COLUMNS
  // ----------------------------------------------------

  const columns = [
    {
      id: 'Id',
      header: '#',
      accessorKey: 'Id',
    },

    {
      id: 'Kupac',
      header: 'Kupac',
      accessorKey: 'Kupac',
    },

    {
      id: 'KontaktOsoba',
      header: 'Kontakt osoba',
      accessorKey: 'KontaktOsoba',
    },

    {
      id: 'VozacIme',
      header: 'Vozač',
      accessorKey: 'VozacIme',
    },

    {
      id: 'VozacTel',
      header: 'Telefon',
      accessorKey: 'VozacTel',
    },

    {
      id: 'DatumUtovara',
      header: 'Datum utovara',
      cell: ({row}) =>
        row.original.DatumUtovara ? moments(row.original.DatumUtovara).format('DD.MM.YYYY') : '',
    },

    {
      id: 'GranicniPrelaz',
      header: 'Granični prelaz',
      accessorKey: 'GranicniPrelaz',
    },

    {
      id: 'BrojNaloga',
      header: 'Nalozi',
      cell: ({row}) => (
        <div>
          {row.original.stavke?.map((stavka: any, index: number) => (
            <div key={index}>{stavka.BrojNaloga}</div>
          ))}
        </div>
      ),
    },
    {
      id: 'Napomena',
      header: 'Napomena',
      cell: ({row}) => (
        <div>
          {row.original.stavke?.map((stavka: any, index: number) => (
            <div key={index}>{stavka.Napomena}</div>
          ))}
        </div>
      ),
    },

    {
      id: 'CreatedAt',
      header: 'Kreirano',
      cell: ({row}) => {
        const kreirano = getValue(row.original, ['Kreirano', 'CreatedAt'])

        return kreirano ? moments(kreirano).format('DD.MM.YYYY HH:mm') : ''
      },
    },

    {
      id: 'Kreirao',
      header: 'Kreirao',
      accessorKey: 'uposlenik.UposlenikImePrezime',
    },

    {
      id: 'NaloziDetalji',
      header: 'Nalozi',
      cell: ({row}) => (
        <button
          type='button'
          className='btn btn-icon btn-light-info btn-sm'
          onClick={() => openNaloziModal(row.original)}
        >
          <KTIcon iconName='eye' className='fs-2' />
        </button>
      ),
    },

    {
      id: 'PDF',
      header: 'PDF',
      cell: ({row}) => (
        <button
          type='button'
          className='btn btn-icon btn-light-primary btn-sm'
          onClick={() => openPdf(row.original)}
        >
          <KTIcon iconName='document' className='fs-2' />
        </button>
      ),
    },

    {
      header: 'Akcija',
      accessorKey: 'Akcija',

      cell: ({row}) => (
        <TableActionButton
          onDelete={() => onDelete(row.original.Id)}
          onEdit={() => openEditModal(row.original)}
        />
      ),
    },
  ].filter((column: any) => !['GranicniPrelaz', 'BrojNaloga', 'Napomena'].includes(column.id))

  // ----------------------------------------------------
  // TABLE
  // ----------------------------------------------------

  const table = useReactTable({
    data: data,

    columns,

    getCoreRowModel: getCoreRowModel(),

    getSortedRowModel: getSortedRowModel(),

    state: {
      sorting: sorting,
      globalFilter: globalFilter,
    },

    onGlobalFilterChange: setGlobalFilter,

    getFilteredRowModel: getFilteredRowModel(),

    onSortingChange: setSorting,
  })

  // ----------------------------------------------------
  // DELETE
  // ----------------------------------------------------

  const onDelete = (id: number) => {
    deleteNajavaUtovara(id)
      .then((response) => {
        notifyToast(true, response.message)

        updatePage()
      })
      .catch((error) => {
        notifyToast(false, error?.response?.data?.message ?? error)
      })
  }

  // ----------------------------------------------------
  // EDIT
  // ----------------------------------------------------

  const saveEdit = () => {
    if (!selectedNajavaId) {
      return
    }

    const payload = {
      kupac: editForm.kupac,
      kontaktOsoba: editForm.kontaktOsoba,

      vozacIme: editForm.vozacIme,
      VozacFirma: editForm.vozacFirma,
      vozacTel: editForm.vozacTel,

      regKamion: editForm.regKamion,
      regPrikolica: editForm.regPrikolica,

      datumUtovara: editForm.datumUtovara,
      vrijemeUtovara: editForm.vrijemeUtovara,

      granicniPrelaz: editForm.granicniPrelaz,
      brojPasosa: editForm.brojPasosa,

      emailDokumentacija: editForm.emailDokumentacija,
      napomene: editForm.napomene,
      napomena: editForm.napomene,

      DodatniUtovar: editForm.dodatniUtovarRobe === 'DA',
      UgovorenaCijenaTransportaKM: editForm.ugovorenaCijenaBam,
      UgovorenaCijenaTransportaEUR: editForm.ugovorenaCijenaEur,
      DodatniUtovarNalozi: editForm.brojNalogaDodatniUtovarRobe,
      Transport: editForm.transport,
      FakturisatiTransport: editForm.fakturisatiTransport === 'DA',
      FakturisatiTransportNalog: editForm.fakturisatiTransportNalog,
      CarisnkiPostupak: editForm.carisnkiPostupak,

      stavke: editStavke.map((stavka: any) => ({
        id: getValue(stavka, ['Id', 'id'], undefined),
        brojNaloga: getValue(stavka, ['BrojNaloga', 'brojNaloga']),
        stavka: getStavkaValue(stavka),
        brojPonude: getValue(stavka, ['BrojPonude', 'brojPonude']),
        sifraArtikla: getSifraValue(stavka),
        boja: getBojaValue(stavka),
        brojPaketa: getValue(stavka, ['BrojPaketa', 'brojPaketa']),
        napomena: stavka.napomena ?? '',
        Istovar: stavka.istovar ?? '',
        Istovar1: editForm.istovar1,
        KontaktIstovar1: editForm.istovar1Kontakt,
        Istovar2: editForm.istovar2,
        KontaktIstovar2: editForm.istovar2Kontakt,
      })),
    }

    setLoading(true)

    updateNajavaUtovara(selectedNajavaId, payload)
      .then((response) => {
        notifyToast(true, response?.message ?? 'Najava utovara uspjesno izmijenjena.')
        setShowEditModal(false)
        setSelectedNajavaId(null)
        updatePage()
      })
      .catch((error) => {
        console.error(error)
        notifyToast(
          false,
          error?.response?.data?.message ?? 'Greska prilikom izmjene najave utovara.'
        )
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <>
      <KTCard>
        <ToastContainer />

        <KTCardBody className='py-4'>
          <div className='rounded border border-primary border-dashed bg-light-primary p-5 mb-6 d-flex flex-wrap align-items-center justify-content-between gap-4'>
            <div>
              <h3 className='mb-2'>Thermoboard</h3>
              <p className='text-gray-700 mb-0'>
                Kreirajte najavu utovara za Thermoboard uz ručni unos robe i preuzmite PDF.
              </p>
            </div>
            <button
              type='button'
              className='btn btn-primary'
              onClick={() => setShowThermoboardModal(true)}
            >
              <KTIcon iconName='plus' className='fs-2' />
              Kreiraj najavu
            </button>
          </div>
          <div className='d-flex justify-content-between'>
            <div data-kt-user-table-toolbar='base'>
              <TableSearch onSearch={(text) => setGlobalFilter(text)} />
            </div>

            <div data-kt-user-table-toolbar='base'>
              <ExportButton table={table} filename={'Najava_utovara'} />
            </div>
          </div>

          {loading ? (
            <LoadingComponent />
          ) : (
            <div className='table-responsive mt-3'>
              <table className='table align-middle table-bordered gy-5 no-footer'>
                <thead>
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr
                      key={headerGroup.id}
                      className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-dark p-2'
                    >
                      {headerGroup.headers.map((header) => (
                        <th
                          className='text-white'
                          key={header.id}
                          onClick={header.column.getToggleSortingHandler()}
                        >
                          {flexRender(header.column.columnDef.header, header.getContext())}

                          {/* @ts-ignore */}
                          {header.column.getIsSorted() === 'asc'
                            ? ' 🔼'
                            : header.column.getIsSorted() === 'desc'
                            ? ' 🔽'
                            : ''}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody className='text-gray-600'>
                  {table.getRowModel().rows && table.getRowModel().rows.length > 0 ? (
                    table.getRowModel().rows.map((row) => (
                      <tr key={row.id}>
                        {row.getVisibleCells().map((cell) => (
                          <td key={cell.id}>
                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={table.getVisibleLeafColumns().length}>
                        <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                          No matching records found
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          <TablePagination
            updatePage={(page, per_page) =>
              setparams({
                ...params,
                page: page,
                per_page: per_page,
              })
            }
            pagination={pagination}
          />
        </KTCardBody>
      </KTCard>

      {showThermoboardModal && (
        <ThermoboardNajavaModal
          initialKupac={kupacFilter}
          onClose={() => setShowThermoboardModal(false)}
          onCreated={updatePage}
        />
      )}

      {showNaloziModal && selectedNaloziNajava && (
        <>
          <div
            className='modal fade show d-block'
            tabIndex={-1}
            style={{background: 'rgba(0,0,0,0.5)'}}
          >
            <div className='modal-dialog modal-xl'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h2 className='fw-bolder'>Nalozi</h2>

                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-active-color-primary'
                    onClick={() => {
                      setShowNaloziModal(false)
                      setSelectedNaloziNajava(null)
                      setLoadingNaloziModal(false)
                    }}
                  >
                    <KTIcon iconName='cross' className='fs-1' />
                  </button>
                </div>

                <div className='modal-body'>
                  {loadingNaloziModal && (
                    <div className='mb-5'>
                      <LoadingComponent />
                    </div>
                  )}

                  <div className='row g-6 mb-6'>
                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Adresa Istovara 1</label>
                      <input
                        type='text'
                        className='form-control'
                        value={getValue(selectedNaloziNajava.stavke?.[0], ['Istovar1', 'istovar1'])}
                        readOnly
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Kontakt Istovara 1</label>
                      <input
                        type='text'
                        className='form-control'
                        value={getValue(selectedNaloziNajava.stavke?.[0], [
                          'KontaktIstovar1',
                          'kontaktIstovar1',
                          'Istovar1Kontakt',
                        ])}
                        readOnly
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Adresa Istovara 2</label>
                      <input
                        type='text'
                        className='form-control'
                        value={getValue(selectedNaloziNajava.stavke?.[0], ['Istovar2', 'istovar2'])}
                        readOnly
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Kontakt Istovara 2</label>
                      <input
                        type='text'
                        className='form-control'
                        value={getValue(selectedNaloziNajava.stavke?.[0], [
                          'KontaktIstovar2',
                          'kontaktIstovar2',
                          'Istovar2Kontakt',
                        ])}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className='table-responsive'>
                    <table className='table table-bordered align-middle'>
                      <thead>
                        <tr className='fw-bold bg-light'>
                          <th>Broj naloga</th>
                          <th>Stavka</th>
                          <th>Broj ponude</th>
                          <th>Sifra</th>
                          <th>Boja</th>
                          <th>Brojevi paketa</th>
                          <th>Napomena</th>
                          <th>Istovar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedNaloziNajava.stavke?.map((stavka: any, index: number) => (
                          <tr key={getValue(stavka, ['Id', 'id'], index)}>
                            <td>{getValue(stavka, ['BrojNaloga', 'brojNaloga'])}</td>
                            <td>{getStavkaValue(stavka)}</td>
                            <td>{getValue(stavka, ['BrojPonude', 'brojPonude'])}</td>
                            <td>{getSifraValue(stavka)}</td>
                            <td>{getBojaValue(stavka)}</td>
                            <td>{getValue(stavka, ['BrojPaketa', 'brojPaketa'])}</td>
                            <td>{getValue(stavka, ['napomena', 'Napomena'])}</td>
                            <td>{getValue(stavka, ['istovar', 'Istovar'])}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => {
                      setShowNaloziModal(false)
                      setSelectedNaloziNajava(null)
                      setLoadingNaloziModal(false)
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className='modal-backdrop fade show'></div>
        </>
      )}

      {showEditModal && (
        <>
          <div
            className='modal fade show d-block'
            tabIndex={-1}
            style={{background: 'rgba(0,0,0,0.5)'}}
          >
            <div className='modal-dialog modal-xl'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h2 className='fw-bolder'>Najava utovara</h2>

                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-active-color-primary'
                    onClick={() => setShowEditModal(false)}
                  >
                    <KTIcon iconName='cross' className='fs-1' />
                  </button>
                </div>

                <div className='modal-body'>
                  <div className='row g-6'>
                    <div className='col-md-12'>
                      <label className='form-label fw-bold'>Naziv kupca</label>
                      <input
                        type='text'
                        className='form-control'
                        value={editForm.kupac ?? ''}
                        readOnly
                      />
                    </div>

                    <div className='col-md-12'>
                      <label className='form-label fw-bold'>
                        Alternativa - Kontakt osoba i tel
                      </label>
                      <input
                        type='text'
                        className='form-control'
                        value={editForm.kontaktOsoba ?? ''}
                        onChange={(e) => setEditField('kontaktOsoba', e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Adresa Istovara 1</label>
                      <input
                        type='text'
                        className='form-control'
                        value={editForm.istovar1 ?? ''}
                        onChange={(e) => setEditField('istovar1', e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Istovar 1 Kontakt</label>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='Ime i broj telefona'
                        value={editForm.istovar1Kontakt ?? ''}
                        onChange={(e) => setEditField('istovar1Kontakt', e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Adresa Istovara 2</label>
                      <input
                        type='text'
                        className='form-control'
                        value={editForm.istovar2 ?? ''}
                        onChange={(e) => setEditField('istovar2', e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Istovar 2 Kontakt</label>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='Ime i broj telefona'
                        value={editForm.istovar2Kontakt ?? ''}
                        onChange={(e) => setEditField('istovar2Kontakt', e.target.value)}
                      />
                    </div>

                    <div className='col-md-12'>
                      <h3 className='fw-bolder mb-5'>Informacije o robi</h3>
                      <div className='table-responsive'>
                        <table className='table table-bordered align-middle'>
                          <thead>
                            <tr className='fw-bold bg-light'>
                              <th>Broj naloga</th>
                              <th>Stavka</th>
                              <th>Broj ponude</th>
                              <th>Sifra</th>
                              <th>Boja</th>
                              <th>Brojevi paketa</th>
                              <th>Napomena</th>
                              <th>Odaberi Istovar</th>
                            </tr>
                          </thead>
                          <tbody>
                            {editStavke.map((stavka: any, index: number) => (
                              <tr key={getValue(stavka, ['Id', 'id'], index)}>
                                <td>{getValue(stavka, ['BrojNaloga', 'brojNaloga'])}</td>
                                <td>{getStavkaValue(stavka)}</td>
                                <td>{getValue(stavka, ['BrojPonude', 'brojPonude'])}</td>
                                <td>{getSifraValue(stavka)}</td>
                                <td>{getBojaValue(stavka)}</td>
                                <td style={{minWidth: '180px'}}>
                                  <input
                                    type='text'
                                    className='form-control form-control-solid'
                                    placeholder='Brojevi paketa'
                                    value={getValue(stavka, ['BrojPaketa', 'brojPaketa'])}
                                    onChange={(e) => {
                                      const updated = [...editStavke]
                                      updated[index].BrojPaketa = e.target.value
                                      updated[index].brojPaketa = e.target.value
                                      setEditStavke(updated)
                                    }}
                                  />
                                </td>
                                <td style={{minWidth: '250px'}}>
                                  <input
                                    type='text'
                                    className='form-control form-control-solid'
                                    placeholder='Napomena'
                                    value={stavka.napomena ?? ''}
                                    onChange={(e) => {
                                      const updated = [...editStavke]
                                      updated[index].napomena = e.target.value
                                      setEditStavke(updated)
                                    }}
                                  />
                                </td>
                                <td style={{minWidth: '160px'}}>
                                  <select
                                    className='form-control form-control-solid'
                                    value={stavka.istovar ?? ''}
                                    onChange={(e) => {
                                      const updated = [...editStavke]
                                      updated[index].istovar = e.target.value
                                      setEditStavke(updated)
                                    }}
                                  >
                                    <option value=''>Odaberi</option>
                                    <option value='Istovar 1'>Istovar 1</option>
                                    <option value='Istovar 2'>Istovar 2</option>
                                  </select>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className='form-text'>
                          Pored svakog paketa ide zarez osim zadnjeg. Primjer: 101, 102, 103
                        </div>
                      </div>
                    </div>

                    <div className='col-md-12 mt-10'>
                      <h3 className='fw-bolder mb-5'>Informacije o prevozu</h3>
                    </div>

                    <div className='col-md-4'>
                      <label className='form-label fw-bold'>Ime i prezime vozaca</label>
                      <div className='position-relative'>
                        <div className='input-group'>
                          <input
                            type='text'
                            className='form-control'
                            value={editForm.vozacIme ?? ''}
                            readOnly={Boolean(selectedVozac)}
                            onChange={(e) => {
                              setEditField('vozacIme', e.target.value)
                              setSelectedVozac(null)
                            }}
                          />

                          {selectedVozac && (
                            <button
                              type='button'
                              className='btn btn-light'
                              onClick={clearSelectedVozac}
                            >
                              Promijeni
                            </button>
                          )}
                        </div>

                        {!selectedVozac && String(editForm.vozacIme ?? '').trim().length >= 3 && (
                          <div
                            className='position-absolute start-0 end-0 bg-white border rounded shadow-sm mt-1'
                            style={{zIndex: 1060, maxHeight: 260, overflowY: 'auto'}}
                          >
                            {vozaciLoading ? (
                              <div className='px-4 py-3 text-muted'>Pretraga vozaca...</div>
                            ) : vozaciOptions.length > 0 ? (
                              vozaciOptions.map((vozac: any, index: number) => (
                                <button
                                  key={vozac?.PartnerId ?? vozac?.Id ?? index}
                                  type='button'
                                  className='btn btn-white w-100 text-start px-4 py-3 border-bottom'
                                  onClick={() => selectVozac(vozac)}
                                >
                                  <div className='fw-bold'>
                                    {vozac?.ImePrezimeVozaca ?? vozac?.PartnerNaziv ?? '-'}
                                  </div>
                                  <div className='text-muted small'>
                                    {[vozac?.PartnerMobitel, vozac?.RegistracijaKamiona ?? vozac?.Registracija]
                                      .filter(Boolean)
                                      .join(' | ')}
                                  </div>
                                </button>
                              ))
                            ) : vozaciSearchTouched ? (
                              <div className='px-4 py-3'>
                                <div className='text-muted mb-3'>Nema pronadjenih vozaca.</div>
                                <button
                                  type='button'
                                  className='btn btn-sm btn-primary'
                                  onClick={() => navigate('/sifarnici/partneri/dodaj')}
                                >
                                  Dodaj vozaca
                                </button>
                              </div>
                            ) : null}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='col-md-4'>
                      <label className='form-label fw-bold'>Vozac Firma</label>
                      <input
                        type='text'
                        className='form-control'
                        value={editForm.vozacFirma ?? ''}
                        onChange={(e) => setEditField('vozacFirma', e.target.value)}
                      />
                    </div>

                    <div className='col-md-4'>
                      <label className='form-label fw-bold'>Tel</label>
                      <input
                        type='text'
                        className='form-control'
                        value={editForm.vozacTel ?? ''}
                        onChange={(e) => setEditField('vozacTel', e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Reg oznaka kamiona</label>
                      <input
                        type='text'
                        className='form-control'
                        value={editForm.regKamion ?? ''}
                        onChange={(e) => setEditField('regKamion', e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Reg oznaka prikolice</label>
                      <input
                        type='text'
                        className='form-control'
                        value={editForm.regPrikolica ?? ''}
                        onChange={(e) => setEditField('regPrikolica', e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Datum utovara</label>
                      <input
                        type='date'
                        className='form-control'
                        value={editForm.datumUtovara ?? ''}
                        onChange={(e) => setEditField('datumUtovara', e.target.value)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label fw-bold'>Vrijeme utovara</label>
                      <input
                        type='time'
                        className='form-control'
                        value={editForm.vrijemeUtovara ?? ''}
                        onChange={(e) => setEditField('vrijemeUtovara', e.target.value)}
                      />
                    </div>

                    <div className='col-md-12 mt-10'>
                      <h3 className='fw-bolder mb-5'>Cijena transporta</h3>

                      <div className='row g-6'>
                        <div className='col-md-6'>
                          <label className='form-label fw-bold'>BAM</label>
                          <input
                            type='number'
                            step='0.01'
                            className='form-control'
                            value={editForm.ugovorenaCijenaBam ?? ''}
                            onChange={(e) => handleEditPriceBamChange(e.target.value)}
                          />
                        </div>

                        <div className='col-md-6'>
                          <label className='form-label fw-bold'>EUR</label>
                          <input
                            type='number'
                            step='0.01'
                            className='form-control'
                            value={editForm.ugovorenaCijenaEur ?? ''}
                            onChange={(e) => handleEditPriceEurChange(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='col-md-12 mt-10'>
                      <label className='form-label fw-bold'>Fakturisati transport</label>
                      <select
                        className='form-control'
                        value={editForm.fakturisatiTransport ?? ''}
                        onChange={(e) => {
                          setEditForm((prev: any) => ({
                            ...prev,
                            fakturisatiTransport: e.target.value,
                            fakturisatiTransportNalog:
                              e.target.value === 'DA' ? prev.fakturisatiTransportNalog : '',
                          }))
                        }}
                      >
                        <option value=''>Odaberi</option>
                        <option value='DA'>DA</option>
                        <option value='NE'>NE</option>
                      </select>
                    </div>

                    {editForm.fakturisatiTransport === 'DA' && (
                      <div className='col-md-12'>
                        <label className='form-label fw-bold'>Broj naloga za fakturisati</label>
                        <input
                          type='text'
                          className='form-control'
                          value={editForm.fakturisatiTransportNalog ?? ''}
                          onChange={(e) =>
                            setEditField('fakturisatiTransportNalog', e.target.value)
                          }
                        />
                      </div>
                    )}

                    <div className='col-md-12 mt-10'>
                      <label className='form-label fw-bold'>Vrsta transporta</label>
                      <select
                        className='form-control'
                        value={editForm.transport ?? ''}
                        onChange={(e) => {
                          setEditForm((prev: any) => ({
                            ...prev,
                            transport: e.target.value,
                            carisnkiPostupak: e.target.value === 'ino' ? prev.carisnkiPostupak : '',
                          }))
                        }}
                      >
                        <option value=''>Odaberi</option>
                        <option value='domaci'>Domaci</option>
                        <option value='ino'>Ino</option>
                      </select>
                    </div>

                    <div className='col-md-12 mt-10'>
                      <h3 className='fw-bolder mb-5'>Dodatne informacije o prevozu za izvoz</h3>
                    </div>

                    <div className='col-md-6'>
                      <div className='row g-6'>
                        <div className='col-md-12'>
                          <label className='form-label fw-bold'>Granicni prelaz</label>
                          <input
                            type='text'
                            className='form-control'
                            value={editForm.granicniPrelaz ?? ''}
                            onChange={(e) => setEditField('granicniPrelaz', e.target.value)}
                          />
                        </div>

                        <div className='col-md-12'>
                          <label className='form-label fw-bold'>
                            Broj licne karte / pasosa vozaca
                          </label>
                          <input
                            type='text'
                            className='form-control'
                            value={editForm.brojPasosa ?? ''}
                            onChange={(e) => setEditField('brojPasosa', e.target.value)}
                          />
                        </div>
                      </div>
                    </div>

                    {editForm.transport === 'ino' && (
                      <div className='col-md-6'>
                        <label className='form-label fw-bold'>Carinski postupak</label>

                        <div className='d-flex gap-10 flex-wrap'>
                          <label className='form-check form-check-custom form-check-solid'>
                            <input
                              className='form-check-input'
                              type='radio'
                              name='editCarisnkiPostupak'
                              value='pojednostavljeni izvoz'
                              checked={editForm.carisnkiPostupak === 'pojednostavljeni izvoz'}
                              onChange={(e) => setEditField('carisnkiPostupak', e.target.value)}
                            />
                            <span className='form-check-label'>pojednostavljeni izvoz</span>
                          </label>

                          <label className='form-check form-check-custom form-check-solid'>
                            <input
                              className='form-check-input'
                              type='radio'
                              name='editCarisnkiPostupak'
                              value='redovni izvoz'
                              checked={editForm.carisnkiPostupak === 'redovni izvoz'}
                              onChange={(e) => setEditField('carisnkiPostupak', e.target.value)}
                            />
                            <span className='form-check-label'>redovni izvoz</span>
                          </label>
                        </div>
                      </div>
                    )}

                    <div className='col-md-12'>
                      <label className='form-label fw-bold'>E-mail za slanje dokumentacije</label>
                      <input
                        type='text'
                        className='form-control'
                        value={editForm.emailDokumentacija ?? ''}
                        onChange={(e) => setEditField('emailDokumentacija', e.target.value)}
                      />
                    </div>

                    <div className='col-md-12'>
                      <label className='form-label fw-bold'>Dodatne napomene</label>
                      <textarea
                        className='form-control'
                        rows={4}
                        value={editForm.napomene ?? ''}
                        onChange={(e) => setEditField('napomene', e.target.value)}
                      />
                    </div>

                    <div className='col-md-12 mt-10'>
                      <label className='form-label fw-bold'>Dodatni utovar robe</label>
                      <select
                        className='form-control'
                        value={editForm.dodatniUtovarRobe ?? ''}
                        onChange={(e) => {
                          setEditForm((prev: any) => ({
                            ...prev,
                            dodatniUtovarRobe: e.target.value,
                            brojNalogaDodatniUtovarRobe:
                              e.target.value === 'DA' ? prev.brojNalogaDodatniUtovarRobe : '',
                          }))
                        }}
                      >
                        <option value=''>Odaberi</option>
                        <option value='DA'>DA</option>
                        <option value='NE'>NE</option>
                      </select>
                    </div>

                    {editForm.dodatniUtovarRobe === 'DA' && (
                      <div className='col-md-12'>
                        <label className='form-label fw-bold'>
                          Broj naloga za dodatni utovar robe
                        </label>
                        <input
                          type='text'
                          className='form-control'
                          value={editForm.brojNalogaDodatniUtovarRobe ?? ''}
                          onChange={(e) =>
                            setEditField('brojNalogaDodatniUtovarRobe', e.target.value)
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => setShowEditModal(false)}
                  >
                    Close
                  </button>

                  <button type='button' className='btn btn-primary' onClick={saveEdit}>
                    Sacuvaj izmjene
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className='modal-backdrop fade show'></div>
        </>
      )}
    </>
  )
}

export default NajaveUtovaraList
